import type { Dict } from "./pl.js";

export const zh: Dict = {
  navCats: "服务类别",
  navHow: "使用流程",
  navOps: "面向商家",
  navPrice: "价格",
  navContact: "联系",
  navBook: "商家后台演示",
  pill: "面向服务业商家的预订平台",
  title1: "你的服务，",
  title2: "自动完成预订。",
  sub: "b00k 把客房、车辆、门诊等各类服务的日历整合到一个预订系统里。客户通过网页和聊天自助预订，系统负责看管时段并阻止冲突。",
  ctaBook: "创建商家账户",
  ctaOperator: "查看客户端界面",
  heroMeta: "你的公司.B00K.ONLINE · 每个商家拥有独立子域名",
  cardChip: "已确认",
  cardNote: "预订从网页和聊天自动流入，并立即锁定排期。",
  catsKick: "服务类别",
  catsTitle: "b00k 能承载哪些业务",
  catsSub: "一个平台承载全部服务。按小时的服务依次排开；客房与车辆按天并行预订。",
  cat1t: "客房",
  cat1d: "按一晚或多晚预订的客房与公寓。同一档期内多间客房可并行预订。",
  cat2t: "车辆",
  cat2d: "按天出租的城市车与 SUV。可用性日历看管取车与还车。",
  cat3t: "休闲项目",
  cat3d: "桑拿、水疗、皮划艇。按具体时间预订，时长固定。",
  cat4t: "美发",
  cat4d: "剪发与染发。你选定时间，系统按服务实际时长精确锁定。",
  cat5t: "美容",
  cat5d: "美甲与按摩。可与其他服务组合，时长自动合并为一段。",
  cat6t: "医疗",
  cat6d: "定时的问诊与检查。诊室日历自动保持有序。",
  cat7t: "维修",
  cat7d: "汽车、自行车或笔记本电脑，我们都能覆盖。",
  cat8t: "课外辅导",
  cat8d: "语言课或钢琴课，都可以在我们的平台上安排。",
  cat9t: "其他",
  cat9d: "你所在行业的特点 + 我们的经验 = 成功。",
  howKick: "使用流程",
  howTitle: "三步搞定，无需通话",
  s1t: "添加服务与资源",
  s1d: "录入客房、车辆和预约项目，填写时长与价格。注册时系统会校验每一个账户——你的和客户的。",
  s2t: "客户自助预订",
  s2d: "通过网页或聊天——WhatsApp 与 Messenger。时长自动累加，客房并行预订，客户只会看到真正空闲的时段。",
  s3t: "系统看管排期",
  s3d: "一经确认，时段即被锁定——两个人永远不会订到同一时间的同一服务。取消与改期同样受支持。",
  newChip: "新功能",
  chatLine: "你的客户可以边聊天边预订——通过 WhatsApp 或 Messenger。",
  opsKick: "面向商家",
  opsTitle: "让排期替你工作",
  opsSub: "客房、车辆与预约同在一张日历上。冲突自动阻止，聊天预订自动流入，入住率与营收实时可见。",
  opsCta: "查看商家后台",
  f1: "当日日历与资源占用同屏可见",
  f2: "自动阻止时段冲突",
  f3: "来自网页与聊天的预订——WhatsApp / Messenger",
  f4: "客户、预订备注与关键指标",
  priceKick: "价格",
  priceTitle: "像预订一样简单",
  month: "月",
  recommended: "推荐",
  soon: "即将上线",
  custom: "面议",
  opsSuffix: "名员工",
  priceNote: "月费取决于有后台访问权限的员工人数。",
  t1f1: "日历与网页预订",
  t1f2: "WhatsApp / Messenger 聊天",
  t1f3: "客户、备注与提醒",
  t2f1: "包含 SOLO 全部功能",
  t2f2: "资源与服务不限数量",
  t2f3: "报表与出租率指标",
  t3f1: "包含 TEAM 全部功能",
  t3f2: "员工排班与角色",
  t3f3: "API 与集成",
  t4f1: "包含 GROUP 全部功能",
  t4f2: "实施支持与服务等级协议",
  t4f3: "定制合同与结算",
  conKick: "联系与交通",
  conTitle: "你的位置，他们的路线",
  dirKick: "交通指引——客户看到的样子",
  dir1: "自驾：从耶莱尼亚古拉走 3 号国道，从什克拉尔斯卡波伦巴市中心出口下，再沿 Zdrojowa 街行驶 5 分钟。",
  dir2: "乘火车：什克拉尔斯卡波伦巴上站，步行 12 分钟前往市中心方向。",
  dir3: "现场提供访客停车位——免费，无需预约。",
  footUser: "客户端界面",
  footOp: "商家后台",

  wizTitle: "创建商家账户",
  wizSub: "七个步骤。完成后你将拥有专属子域名和可直接使用的后台。",
  wizStep1: "公司",
  wizStep2: "子域名",
  wizStep3: "行业",
  wizStep4: "套餐",
  wizStep5: "管理员",
  wizStep6: "支付",
  wizStep7: "确认信息",
  wizNext: "下一步",
  wizBack: "上一步",
  wizFinish: "创建账户",
  fCompany: "公司名称",
  fNip: "税号（NIP）",
  fPhone: "电话",
  fAddress: "地址",
  fSlug: "子域名",
  slugHint: "客户将在这个地址预订你的服务。",
  slugChecking: "正在检查可用性…",
  slugFree: "该子域名可用。",
  slugTaken: "该子域名已被占用。",
  slugInvalid: "子域名：3–63 个字符，小写字母、数字和连字符（不能位于首尾）。",
  industriesHint: "选择你经营的行业。之后随时可以在后台增加。",
  planHint: "套餐随时可改——不会丢失数据。",
  fName: "姓名",
  fEmail: "电子邮箱",
  fPass: "密码（至少 8 个字符）",
  fPass2: "再次输入密码",
  fTerms: "我接受 b00k.online 的服务条款，并同意为办理预订处理相关数据。",
  payTitle: "客户支付",
  payHint: "可选。你可以在确认预订时收取在线付款。",
  payEnable: "接受在线支付",
  payMethods: "支付方式",
  sumTitle: "确认信息",
  sumCompany: "公司",
  sumSub: "子域名",
  sumIndustries: "行业",
  sumPlan: "套餐",
  sumAdmin: "管理员",
  sumPayments: "支付",
  yes: "是",
  no: "否",
  doneTitle: "商家账户已就绪",
  doneSub: "你的子域名已上线。登录后台添加服务——预订即刻开始。",
  doneOpen: "打开商家后台",
  doneBooking: "查看预订页面",
  companyProofOk: "已以公司管理员身份登录：",
  companyLoginOther: "使用其他账户登录",
  errGeneric: "账户创建失败。请检查信息后重试。",
};
